module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAc0lEQVR42u3QURGAQABCQZIYxFh2s4K1uC9TsMy8AGzaZrnp8wAAAAAAAAAAAAAAtLneu0sBAAAAAAAAAAAAAAAAwN/aAAAAAAAAAAAAAAAAAKDJ83UpAAAAAAAAAAAAAAAAAACwHAAAAAAAAAAAAAAAox0Li3Oclc8FPAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Sierra-Leone.png
// module id = EeIk
// module chunks = 0 62 63